<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="columnsGrid"
      :columns="gridColumns1"
      :dataset="'dsColumn'"
      :showDisplayCountControl="false"
      :showMoveControl="true"
      :multiselect="true"
      :initialPagesize="10"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="addRow"
        >
          {{ $t('MSG_BTN_ROW_ADD') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="deleteRows"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
      </div>
      <div class="btn_wrapR">
        <sui-button
          v-show="this.objectTypeCode==='N'"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickAdd"
        >
          {{ $t('MSG_BTN_ADD') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="mrB30" />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import BasePage from '~cm/components/BasePage';

const CODE_KEYS = ['COD_COL_TYPE'];

export default {
  name: 'PGE_CMU_00016_T02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    objectId: {
      type: String,
      default: '',
    },
    objectTypeCode: {
      type: String,
      default: '',
    },    
    tableColumnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      optionList: {
        COD_COL_TYPE: [],
      },
    };
  },
  datasets: [{
    id: 'dsColumn',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'objectColumnUid', map: 'objectColumnUid' },
      { type: 'string', name: 'tablePhysicalName', map: 'tablePhysicalName' },
      { type: 'string', name: 'columnName', map: 'columnName' },
      { type: 'string', name: 'dataName', map: 'dataName' },
      { type: 'string', name: 'columnTypeCode', map: 'columnTypeCode' },
      { type: 'string', name: 'columnSizeValue', map: 'columnSizeValue' },
      { type: 'string', name: 'inputSizeValue', map: 'inputSizeValue' },
      { type: 'string', name: 'primaryKeyYn', map: 'primaryKeyYn' },
      { type: 'string', name: 'notNullYn', map: 'notNullYn' },
      { type: 'string', name: 'searchItemYn', map: 'searchItemYn' },
      { type: 'string', name: 'listItemYn', map: 'listItemYn' },
      { type: 'string', name: 'codeId', map: 'codeId' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'objectColumnMultilanguageId', map: 'objectColumnMultilanguageId' },
      { type: 'string', name: 'messageResourceValue', map: 'messageResourceValue' },
      { type: 'string', name: 'addInformationValue', map: 'addInformationValue' },
    ],
  },
  {
    id: 'dsColumnDelete',
    type: 'local',
    data: 'localdata2',
    datafields: [
      { type: 'string', name: 'objectColumnUid', map: 'objectColumnUid' },
      { type: 'string', name: 'tablePhysicalName', map: 'tablePhysicalName' },
      { type: 'string', name: 'columnName', map: 'columnName' },
      { type: 'string', name: 'dataName', map: 'dataName' },
      { type: 'string', name: 'columnTypeCode', map: 'columnTypeCode' },
      { type: 'string', name: 'columnSizeValue', map: 'columnSizeValue' },
      { type: 'string', name: 'inputSizeValue', map: 'inputSizeValue' },
      { type: 'string', name: 'primaryKeyYn', map: 'primaryKeyYn' },
      { type: 'string', name: 'notNullYn', map: 'notNullYn' },
      { type: 'string', name: 'searchItemYn', map: 'searchItemYn' },
      { type: 'string', name: 'listItemYn', map: 'listItemYn' },
      { type: 'string', name: 'codeId', map: 'codeId' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'objectColumnMultilanguageId', map: 'objectColumnMultilanguageId' },
      { type: 'string', name: 'messageResourceValue', map: 'messageResourceValue' },
      { type: 'string', name: 'addInformationValue', map: 'addInformationValue' },
    ],
  }],
  computed: {},
  watch: {
    objectId(data) {
      if (data) {
        this.loadColumnList();
      } else {
        this.clearTabGrid();
      }
    },
    tableColumnList: {
      deep: true,
      handler() {
        this.addRowByTable();
      },
    },
  },
  created() {
    this.gridColumns1 = [{
      text: this.$t('MSG_TXT_TAB_NM'),
      datafield: 'tablePhysicalName',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_DATA_NM'),
      datafield: 'dataName',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_COL_NM'),
      datafield: 'columnName',
      createwidget: (row, column, value, htmlElement) => {
        const componentInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
        }, this.dsColumn, this.$refs.columnsGrid);

        const instance = componentInstance.getComponentInstance();
        instance.$on('blur', () => {
          const rowIndex = componentInstance.getDatasetIndex();
          if (utils.isEmpty(componentInstance.dataset.data[rowIndex].objectColumnMultilanguageId)) {
            const autoMlngId = `MSG_TXT_${instance.realText}`;
            componentInstance.dataset.setData(rowIndex, 'objectColumnMultilanguageId', autoMlngId);
          }
        });
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_MLNG_ID'),
      datafield: 'objectColumnMultilanguageId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
          textFieldProps: {
            readonly: false,
            disabled: false,
          },
          buttonProps: {
            disabled: false,
            style: 'comm_btn_InputScr',
          },
          handler: this.findMsgResoVal,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_VAL'),
      datafield: 'messageResourceValue',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
          readonly: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_TYPE'),
      datafield: 'columnTypeCode',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
          optionList: this.optionList.COD_COL_TYPE,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '150px',
    }, {
      text: this.$t('MSG_TXT_COLUMN_SIZE'),
      datafield: 'columnSizeValue',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
          readonly: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '120px',
    }, {
      text: this.$t('MSG_TXT_INPUT_SIZE'),
      datafield: 'inputSizeValue',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
          maxlength: 5,
          mask: 'number',
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '120px',
    }, {
      text: this.$t('MSG_TXT_PK_YN'),
      datafield: 'primaryKeyYn',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory()
          .createCellSegmentBox(row, column, value, htmlElement, {}, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_NN_YN'),
      datafield: 'notNullYn',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory()
          .createCellSegmentBox(row, column, value, htmlElement, {}, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_SRCH_ITEM_YN'),
      datafield: 'searchItemYn',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory()
          .createCellSegmentBox(row, column, value, htmlElement, {}, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_LIST_ITEM_YN'),
      datafield: 'listItemYn',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory()
          .createCellSegmentBox(row, column, value, htmlElement, {}, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_CODE_ID'),
      datafield: 'codeId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_ADD_INFO'),
      datafield: 'addInformationValue',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          trim: true,
        }, this.dsColumn, this.$refs.columnsGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '100px',
    }];
    this.localdata1 = [];
    this.localdata2 = [];
  },
  mounted() {
    this.$nextTick(() => {
      if (this.objectId) {
        this.loadCode();
      }
    });
  },
  beforeUpnotnull() {},
  upnotnulld() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCode() {
      return http.mergeCodeList(this.contextPageId, CODE_KEYS, this.optionList).then(() => {
        if (this.objectId) {
          this.loadColumnList();
        }
      }).catch(() => {});
    },
    loadColumnList() {
      http.request(this.contextPageId, 'DTS_CMU_00074', {
        path: {
          'object-id': this.objectId,
        },
      }).then(res => {
        if(this.objectTypeCode==='E'){
          this.$refs.columnsGrid.showColumn('tablePhysicalName', false);
          this.$refs.columnsGrid.showColumn('columnSizeValue', false);
          this.$refs.columnsGrid.showColumn('dataName', true);
        }else{
          this.$refs.columnsGrid.showColumn('tablePhysicalName', true);
          this.$refs.columnsGrid.showColumn('columnSizeValue', true);
          this.$refs.columnsGrid.showColumn('dataName', false);
        }        
        const columnList = utils.clone(res.data);
        utils.forEach(columnList, (obj, key) => {
          columnList[key].columnSizeValue = obj.columnSizeValue.toString();
          if (columnList[key].columnSizeValue === '0') {
            columnList[key].columnSizeValue = '';
          }
          columnList[key].inputSizeValue = obj.inputSizeValue.toString();
        });

        this.dsColumn.setRawData(columnList);
      }).catch(error => {
        console.log(error);
      });
    },
    clearTabGrid() {
      this.dsColumn.setRawData([]);
    },
    createRowInitData() {
      return {
        objectColumnUid: '',
        objectId: this.objectId,
        tablePhysicalName: '',
        columnName: '',
        columnTypeCode: '',
        columnSizeValue: '',
        inputSizeValue: '0',
        primaryKeyYn: 'N',
        notNullYn: 'N',
        searchItemYn: 'N',
        listItemYn: 'Y',
        codeId: '',
        arrayalOrder: '',
        objectColumnMultilanguageId: '',
        messageResourceValue: '',
        addInformationValue: '',
      };
    },
    validateObjColData(saveData) {
      const result = {
        valid: true,
        msg: '',
        index: 0,
        dataField: '',
      };
      utils.forEach(saveData, (data, index) => {
        if (utils.isEmpty(data.columnName)) {
          result.valid = false;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), index + 1, this.$t('MSG_TXT_COL_NM'));
          result.row = index;
          result.dataField = 'columnName';
          return false;
        }
        return true;
      });
      return result;
    },
    findMsgResoVal(event, dataRow) {
      if (utils.isEmpty(dataRow.objectColumnMultilanguageId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MLNG_ID')));
        return false;
      }
      http.request(this.contextPageId, 'DTS_CMU_00077', {
        path: {
          'message-id': dataRow.objectColumnMultilanguageId,
        },
      }).then(res => {
        const itemData = utils.clone(this.dsColumn.data);
        const rowId = dataRow['dataset-row-id'];
        const rowIndex = utils.findIndex(itemData, o => utils.isEqual(o['dataset-row-id'], rowId));

        if (!utils.isEmpty(res.data)) {
          this.dsColumn.setData(rowIndex, 'messageResourceValue', res.data.multiLanguageContent || '');
        }
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    setArrayalOrder() {
      utils.forEach(this.dsColumn.data, (value, key) => {
        value.arrayalOrder = key;
      });
    },
    addRow() {
      if (utils.isEmpty(this.objectId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_OBJECT')));
      } else {
        const array = [];
        array.push(this.createRowInitData());
        this.dsColumn.addRows(array);
      }
    },
    deleteRows() {
      if (utils.isEmpty(this.objectId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_OBJECT')));
        return false;
      }

      const deleteRows = [];
      const selectedIndexes = this.dsColumn.getSelectedIndexes();
      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }

      utils.forEach(selectedIndexes, index => {
        const rowId = this.dsColumn.data[index]['dataset-row-id'];
        const rowIndex = utils.findIndex(this.dsColumn.originalData, o => utils.isEqual(o['dataset-row-id'], rowId));

        if (rowIndex > -1) {
          deleteRows.push(this.dsColumn.data[index]);
        }
      });

      this.dsColumn.deleteRows(selectedIndexes);
      this.dsColumnDelete.addRows(deleteRows);
      this.dsColumn.clearSelection();

      return null;
    },
    onClickAdd() {
      if (utils.isEmpty(this.objectId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_OBJECT')));
      } else {
        this.$emit('openPopup');
      }
    },
    addRowByTable() {
      const result = [];
      const sortedList = _.sortBy(this.tableColumnList, itm => Number(itm.arrayalOrder));
      utils.forEach(sortedList, value => {
        const index = utils.findIndex(this.dsColumn.data, o => utils.isEqual(o.objectColumnUid, value.objectColumnUid));
        if (index < 0) {
          const item = this.createRowInitData();
          item.tablePhysicalName = value.tablePhysicalName;
          item.columnName = value.columnName;
          item.columnTypeCode = value.columnTypeCode;
          item.columnSizeValue = value.columnSizeValue.toString();
          item.primaryKeyYn = value.primaryKeyYn;
          item.notNullYn = value.notNullYn;
          item.objectColumnMultilanguageId = `MSG_TXT_${value.columnName}`;
          item.messageResourceValue = value.messageResourceValue || value.defaultMessageResourceValue;
          result.push(item);
        }
      });
      this.dsColumn.addRows(result);
    },
    onClickSave() {
      const saveData = this.dsColumn.getRawData();
      const validResult = this.validateObjColData(saveData);
      this.setArrayalOrder();
      if (validResult.valid) {
        utils.forEach(this.dsColumn.data, item => {
          if(this.objectTypeCode==='N'){
            item.dataName = '';
          }else{
            item.tablePhysicalName = '';
          }
        });
        const dataParams = {
          columnList: this.dsColumn.data,
          columnDeleteList: this.dsColumnDelete.data,
        };
        http.request(this.contextPageId, 'DTS_CMU_00075', {
          path: {
            'object-id': this.objectId || '',
          },
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('research');
          this.dsColumn.setRawData();
        }).catch(error => {
          console.log(error);
        });
      } else {
        utils.messageBox('warning', validResult.msg, null, () => {
          this.$refs.columnsGrid.setFocus(validResult.row, validResult.dataField);
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
